import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigation } from "@react-navigation/native";
import React, { useEffect, useState } from 'react';
import { Linking, Modal, View } from 'react-native';
import AuthCodeInput from '../../components/Form/AuthCodeInput';
import HeaderDefault from '../../components/HeaderDefault';
import ModalPaperWallet from '../../components/ModalPaperWallet';
import ModalPurchase from '../../components/ModalPurchase';
import ModalTransfer from '../../components/ModalTransfer';
import { serverDefaultUrl } from '../../services/api';
import paperWalletService from '../../services/paperWalletService';
import transferService from '../../services/transferService';
import toast from '../../utils/toast';
import styles from './styles';

/*
PROPS -> 
qtd float
token activeId/tokenId
userId boolean
*/

const ConfirmPasswordPaperWallet = (props) => {
    const navigation = useNavigation();
    const [password, setPassword] = useState('');
    const [modalVisible, setModalVisible] = useState(false);

    const [paperWalletResponse, setPaperWalletResponse] = useState();

    useEffect(() => {
        //console.log(password);
        if(password.length === 6) {
            transferToken();
        }
    }, [password])

    const transferToken = async () => {
     //   console.log('transfer');
        const token = await AsyncStorage.getItem('JWT_TOKEN');
        paperWalletService.store(token, {
            active_id: props.route.params.token, 
            amount: props.route.params.qtd, 
            password: password
        }).then((response) => {
            if(response.status === 200) {
                setPaperWalletResponse(response.data);
                setModalVisible(!modalVisible);    
            }else{
                if(response?.data?.message) {
                    toast(response?.data?.message, "#DA1414");
                }else{
                    toast("Ocorreu um problema ao realizar o saque! Verifique seu saldo e sua senha", "#DA1414");
                }
            }
        }).catch((error) => {
       //     console.log(error.response);
            if(error.response?.data?.message) {
                toast(error.response?.data?.message, "#DA1414");
            }else{
                toast("Ocorreu um problema ao realizar o saque! Verifique seu saldo e sua senha", "#DA1414");
            }
        });
    }

    return (
        <>
            <HeaderDefault title={'Confirmar Saque'} />

            <View style={styles.container}>
                <AuthCodeInput
                    cellCount={6}
                    isPassword={true}
                    value={password}
                    onValueChange={(value) => setPassword(value)}
                    label="Digite a sua senha "
                />
            </View>

            <Modal
                animationType="fade"
                transparent={false}
                visible={modalVisible}
                statusBarTranslucent={true}
                onRequestClose={() => navigation.navigate('Tabs')}
            >
                <ModalPaperWallet
                    paperWalletResponse={paperWalletResponse}
                    handleCloseModal={() => {
                        setModalVisible(false);
                        navigation.navigate('Tabs');
                    }} 
                    handleCloseWithTransaction={() => {
                        setModalVisible(false);

                        if(paperWalletResponse?.code) {
                            Linking.canOpenURL(serverDefaultUrl+'paper-wallet/view/'+paperWalletResponse?.code).then(supported => {
                                if (supported) {
                                    Linking.openURL(serverDefaultUrl+'paper-wallet/view/'+paperWalletResponse?.code);
                                } else {
                                console.log('url blocked');
                                }
                            });
                        }
                      
                        navigation.navigate({ name: 'Tabs', params: { openTransaction: false } });
                    }}
                    />
            </Modal>
        </>
    );
}

export default ConfirmPasswordPaperWallet;